import React from 'react';
import { Provider } from "react-redux";
import configure from "../../store/configure";
import Layout from "../../component/layout/Layout";
import FormListContainer from "./container/FormListContainer";

const FormListPage = () => {
    return (
        <Provider store={configure}>
            <Layout>
                <FormListContainer />
            </Layout>
        </Provider>
    );
};

export default FormListPage;
